export default __webpack_public_path__ + "static/media/travel.ff74ada5.jpg";